import React, { useState } from "react";
import PropTypes from "prop-types";
import SpinnerLabel from "common/components/spinner-label";

const propTypes = {
  setToggleCouponForm: PropTypes.func.isRequired,
  verifyCouponUrl: PropTypes.string.isRequired,
  applyCouponCodeCallback: PropTypes.func.isRequired,
  couponErrorData: PropTypes.shape({
    code: PropTypes.arrayOf(PropTypes.string)
  }),
  isVerifyingCoupon: PropTypes.bool
};

const AddCouponForm = ({
  setToggleCouponForm,
  verifyCouponUrl,
  applyCouponCodeCallback,
  couponErrorData = {},
  isVerifyingCoupon = false
}) => {
  const [couponCode, setCouponCode] = useState("");
  const [showErrorMessage, setShowErrorMessage] = useState(false);

  const handleApplyCoupon = () => {
    applyCouponCodeCallback(couponCode, verifyCouponUrl);
    setShowErrorMessage(true);
  };

  const handleCancel = () => {
    setToggleCouponForm(false);
    setShowErrorMessage(false);
  };

  const handleCouponChange = e => {
    setCouponCode(e.target.value);
  };

  return (
    <div className="py-2">
      <input
        id="coupon-code-input"
        data-testid="coupon-code-input"
        type="text"
        value={couponCode}
        onChange={e => handleCouponChange(e)}
      />
      {showErrorMessage && couponErrorData?.code && (
        <p id="apply-coupon-errors" className="text-danger">
          Coupon code {couponErrorData?.code[0]}
        </p>
      )}
      <div className="row ml-0 mt-2">
        <button
          type="button"
          className="btn btn-primary btn-sharp"
          id="apply-coupon-btn"
          data-testid="apply-coupon-btn"
          onClick={handleApplyCoupon}
        >
          <SpinnerLabel spin={isVerifyingCoupon} label="Apply" spinningLabel="Apply" />
        </button>
        <button
          type="button"
          className="btn"
          onClick={handleCancel}
          data-testid="coupon-cancel-btn"
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

AddCouponForm.propTypes = propTypes;

export default AddCouponForm;
